/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	InspectorControls,
} from '@wordpress/block-editor';
import { PanelBody,Notice } from '@wordpress/components';
import { CheckboxControl } from '@woocommerce/blocks-checkout';
import { getSetting } from '@woocommerce/settings';
/**
 * Internal dependencies
 */
import './style.scss';
const { recaptcha_url } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { captcha_provider } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { turnstile_img } = getSetting( 'i13-recaptcha-checkout-block_data', '' );
const { hcaptcha_img } = getSetting( 'i13-recaptcha-checkout-block_data', '' );


export const Edit = ( { attributes, setAttributes } ) => {
	const { text } = attributes;
	const blockProps = useBlockProps();
	return (
		<div { ...blockProps }>
			<div id="recaptcha_admin_placeholder" style={{ marginBottom: '10px',marginTop: '10px'}}>
				<div style={{ width: '100%',clear:'both',backgroundColor:'#fff'}}>

				  {captcha_provider === 'google' ? (
						<img src={recaptcha_url} />
					) : captcha_provider === 'turnstile' ? (
						<img src={turnstile_img} />
					)
					: captcha_provider === 'hcaptcha' ? (
						<img src={hcaptcha_img} />
					): (
						<img src={recaptcha_url} />
					)}



				</div>

				<div style={{ width: '100%',clear:'both'}}>

				 {captcha_provider === 'google' ? (

						<Notice
						className="wc-block-components-notices__notice"
						isDismissible={ false }
						status="info"
					>
						{ __(
							'Please note that actual reCaptcha rendering very based on global recaptcha settings. If you have set V3 as settings it will not render anything on frontend as V3 is hidden algorithm based captcha, It will not show anything like I am not Robot or any challenge.',
							'recaptcha-for-woocommerce'
						) }
					</Notice>



					) : captcha_provider === 'turnstile' ? (

						<Notice
						className="wc-block-components-notices__notice"
						isDismissible={ false }
						status="info"
					>
						{ __(
							'Please note that actual captcha rendering very based on global turnstile settings. If you have set hidden captcha in settings it will not render anything on frontend as hidden captcha will not show anything like Verify you are human.',
							'recaptcha-for-woocommerce'
						) }
					</Notice>

					)
					: captcha_provider === 'hcaptcha' ? (

						<Notice
						className="wc-block-components-notices__notice"
						isDismissible={ false }
						status="info"
					>
						{ __(
							'Please note that actual captcha rendering very based on global hcaptcha settings. If you have set hidden captcha in settings it will not render anything on frontend as hidden captcha will not show anything like Verify you are human.',
							'recaptcha-for-woocommerce'
						) }
					</Notice>

					): (

						<Notice
						className="wc-block-components-notices__notice"
						isDismissible={ false }
						status="info"
					>
							{ __(
								'Please note that actual reCaptcha rendering very based on global recaptcha settings. If you have set V3 as settings it will not render anything on frontend as V3 is hidden algorithm based captcha, It will not show anything like I am not Robot or any challenge.',
								'recaptcha-for-woocommerce'
							) }
						</Notice>
					)}




				</div>
			</div>
		</div>
	);
};

export const Save = ( { attributes } ) => {
	const { text } = attributes;
	return (
		<div { ...useBlockProps.save() }>
			<RichText.Content value={ text } />
		</div>
	);
};
